<template>
	<div class="d-flex justify-content-center align-items-center vh-100 p-3">
		<div class="text-center">
			<h1 class="display-1">404</h1>
			<h3 class="fw-bold">Страница не найдена</h3>
			<div class="mt-3">
				<p>Страница, которую вы ищете, не найдена. Попробуйте проверить URL-адрес на наличие ошибок, затем нажмите кнопку обновления страницы в браузере или перейдите на главную страницу.</p>
				<div class="mt-4">
					<router-link :to="{path: '/'}" class="btn btn-primary">На главную</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import lib from '@/lib';

export default {
	name: "PageNotFound",
	mixins: lib.mixins,
};
</script>
